import React from "react";

// Shared Tailwind primitives mirroring the Reporting Dashboard's shadcn/ui
// look (button variants, inputs). Explicit border styles are needed because
// Login.css resets `button`/`input` borders globally.

const BUTTON_BASE =
  "tw-inline-flex tw-items-center tw-justify-center tw-gap-2 tw-whitespace-nowrap tw-rounded-md tw-font-medium tw-transition-colors focus-visible:tw-outline-none focus-visible:tw-ring-2 focus-visible:tw-ring-ring focus-visible:tw-ring-offset-2 disabled:tw-pointer-events-none disabled:tw-opacity-50";

const BUTTON_VARIANTS = {
  primary:
    "tw-border-0 tw-bg-gradient-primary tw-text-primary-foreground hover:tw-opacity-90 tw-shadow-soft",
  outline:
    "tw-border tw-border-solid tw-border-border tw-bg-white tw-text-foreground hover:tw-bg-secondary",
  ghost:
    "tw-border-0 tw-bg-transparent tw-text-muted-foreground hover:tw-bg-secondary hover:tw-text-foreground",
  danger:
    "tw-border-0 tw-bg-transparent tw-text-muted-foreground hover:tw-bg-red-50 hover:tw-text-destructive",
};

const BUTTON_SIZES = {
  sm: "tw-h-8 tw-px-3 tw-text-xs",
  md: "tw-h-9 tw-px-4 tw-text-sm",
  icon: "tw-h-8 tw-w-8 tw-text-sm",
};

export const UiButton = ({
  variant = "primary",
  size = "md",
  className = "",
  type = "button",
  ...rest
}) => (
  <button
    type={type}
    className={`${BUTTON_BASE} ${BUTTON_VARIANTS[variant]} ${BUTTON_SIZES[size]} ${className}`}
    {...rest}
  />
);

export const FIELD =
  "tw-block tw-w-full tw-rounded-md tw-border tw-border-solid tw-border-input tw-bg-white tw-px-3 tw-text-sm tw-text-foreground tw-shadow-none placeholder:tw-text-muted-foreground focus:tw-outline-none focus:tw-ring-2 focus:tw-ring-ring/30";

export const INPUT = `${FIELD} tw-h-10`;
export const INPUT_SM = `${FIELD} tw-h-8 tw-text-xs`;
export const TEXTAREA = `${FIELD} tw-py-2 tw-leading-5 tw-resize-y`;
